import { useMemo } from 'react';
import type { Promocode } from '@shared/types/schema';

export function useDiscountedPrice(price: number | null | undefined, promocode?: Promocode) {
  return useMemo(() => {
    if (!price || !promocode) return price ?? 0;
    if (promocode.isPercentage) {
      const discount = (price * promocode.discountAmount) / 100;
      return Math.max(0, price - discount);
    }
    return Math.max(0, price - promocode.discountAmount);
  }, [price, promocode]);
}
